import { DEFAULT_LANGUAGE } from '../../common/i18n.js'
import { Language } from '../../common/types.js'
import { CompetenceRow } from '../../server/database/types.js'

export const getCompetenceName = (lang: Language, competence: CompetenceRow) => {
    return competence[`name_${lang}`] || competence[`name_${DEFAULT_LANGUAGE}`]
}
